/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import Router from "vue-router";
// ..
import Login from "../views/LoginView";
import Main from "../views/MainView";
import Home from "../views/HomeView";
import Company from "../views/CompaniesList";
import Users from "../views/UsersList";
import Registrations from "../views/RegistrationsList";
import RecurringRegistrations from "../views/RecurringRegistrationsList";
import RegistrationsArchive from "../views/RegistrationsArchiveList";
import DriverRegistration from "../views/DriverRegistration";
import DriverOverview from "../views/DriverOverviewList";

// Routes
function route(path, file, name, children, redirect) {
    return {
        exact: true,
        path,
        name,
        children,
        component: file,
        redirect,
    };
}

Vue.use(Router);

const routes = [
    route("/login", Login, "Login"),
    route(
        "/",
        Main,
        null,
        [
            route("/home", Home, "Home"),
            route("/company", Company, "Company"),
            route("/users", Users, "Users"),
            route("/registrations", Registrations, "Registrations"),
            route(
                "/recurring-registrations",
                RecurringRegistrations,
                "Recurring Registrations"
            ),
            route(
                "/registrations-archive",
                RegistrationsArchive,
                "Registrations Archive"
            ),
            route(
                "/driver-registration",
                DriverRegistration,
                "Driver Registration"
            ),
            route("/driver-overview", DriverOverview, "Driver Overview"),
        ],
        "/home"
    ),
];

// Create a new router
const router = new Router({
    base: __dirname,
    mode: "history",
    routes,
    scrollBehavior: () => ({ y: 0 }),
});

export default router;
